export default __webpack_public_path__ + "static/media/eldred_thumb.b6425281.jpg";